
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import AnimatedText from "../components/animation";
import FadeInOnScroll from "../components/scrollanimation";
// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';


import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import FacebookLogin from '@greatsumini/react-facebook-login';

function Login() {
    const navigate = useNavigate();

    // Hide ? Show Password 
     const [showPassword, setShowPassword] = useState(false); 
    const API_BASE_URL =
      process.env.REACT_APP_API_BASE_URL || "https://ted-talk-phi.vercel.app/api";
    const API_URL = `${API_BASE_URL}/auth/signin`;
// LOgin API Auth..    // 
const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

 const onSubmit = async (data) => {
    console.log("Login Data:", data);

    try {
      const response = await fetch(API_URL,{
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data), 
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Login failed");
      }

      if (result.accessToken) {
        localStorage.setItem("accessToken", result.accessToken);
      }
      if (result.idToken) {
        localStorage.setItem("idToken", result.idToken);
      }
      if (result.refreshToken) {
        localStorage.setItem("refreshToken", result.refreshToken);
      }
      if (result.user) {
        localStorage.setItem("allyUser", JSON.stringify(result.user));
      }
      navigate("/dashboard");
    } catch (error) {
      console.error("Error during login:", error.message);
    }

  };

    // ////// Google Login 
   const GooglehandleSuccess = (credentialResponse) => {
    console.log("Google Credential:", credentialResponse);
    // Send credentialResponse.credential to your backend for verification
  };

  const GooglehandleError = () => {
    console.log("Login Failed");
  };


//   ///// Facebook Login API

  const FacebookhandleSuccess = (response) => {
    console.log('Facebook login success:', response);
    // Send response.accessToken to your backend
  };

  const FacebookhandleFail = (error) => {
    console.log('Facebook login failed:', error);
  };

  const FacebookhandleProfileSuccess = (response) => {
    console.log('Facebook profile:', response);
  };


  // Remberpassword browser 

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  // Load saved credentials if "Remember Me" was checked
  useEffect(() => {
    const savedUsername = localStorage.getItem("username");
    const savedPassword = localStorage.getItem("password"); 
    if (savedUsername && savedPassword) {
      setUsername(savedUsername);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);



   return (
        <div>
            <Header />
            <main>
                <section className="hero">
                    <Container>
                        <Row>
                            <Col className="text-start">
                                    <FadeInOnScroll yOffset={100}>
                                    <h1 className="h1 hero-family">
                                    <AnimatedText text="Grow your business" animationType="fade-up" />

                                    <br /> <AnimatedText text="on" animationType="fade-up" /><b className="green-text"> <AnimatedText text="WhatsApp" animationType="fade-up" /></b></h1>
                                    <p>
                                    <AnimatedText text="Boost engagement and streamline communication with Ally—your AI-powered assistant that automates HR, support, and daily tasks, making interactions faster, smarter, and more personal." animationType="rotate" />
                                    </p>
                                    </FadeInOnScroll>
                                    <FadeInOnScroll yOffset={100}>
                                    <ul className="ul-List">
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>  Targeted Campaigns to deliver personalized offers</li>
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg> Pre-built templates to send updates & reminders</li>
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>24x7 instant engagement with no-code chatbots</li>
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>Powerful automations to resolve issues faster</li>
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>Integrations to bring in context from Zoho, Shopify, etc.</li>
                                    </ul>
                                   </FadeInOnScroll>

                            </Col>
                            <Col className="text-start d-sm-flex justify-content-sm-center align-items-sm-center">
                                <div className="col-9">
                                   
                                    <div className="form-container contact-container">
                                        <h2>Log in to your account</h2>
                                        <p>Welcome back! sign in</p>


                                        <div className="sc-fBuWsC dxzpwU">
    <div className="social-login__item">
             <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
      <div>
        <GoogleLogin onSuccess={GooglehandleSuccess} onError={GooglehandleError} />
      </div>
    </GoogleOAuthProvider>
    </div>
    <div className="social-login__item">

                <FacebookLogin
                    appId="YOUR_FACEBOOK_APP_ID"
                    onSuccess={FacebookhandleSuccess}
                    onFail={FacebookhandleFail}
                    onProfileSuccess={FacebookhandleProfileSuccess}
                />
            
    </div>
</div>

<div className="form__divider">
    <span className="form__divider_text">or Continue with email</span>
</div>
                                      
                                        <form onSubmit={handleSubmit(onSubmit)} noValidate className="ally-registration-form">
                                            
                                                     <label>*Your Business Email</label>
                                           
                                                    <Form.Control
                                                        type="email"
                                                         className="form-control"
                                                         placeholder="Your Business email Address"
                                                       {...register("businessEmailAddress", {
                                                            required: "Business email is required",
                                                            // pattern: {
                                                            // value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                            // message: "Enter a valid email address",
                                                            // },
                                                        })}
                                                    />

                                                     {errors.email && <p className="text-danger">{errors.email.message}</p>}


                                                    <label>*Password</label>
                                                    <div className="position-relative">
                                                        
                                                           <Form.Control
                                                        type={showPassword ? "text" : "password"}
                                                         className="form-control"
                                                         placeholder="password"
                                                       {...register("password", {
                                                            required: "Password is required",
                                                            // minLength: {
                                                            // value: 6,
                                                            // message: "Your Password is Incorrect",
                                                            // }
                                                        })}
                                                    />

                                                    {errors.password && <p className="text-danger">{errors.password.message}</p>}


                                                        <button className="viewpassword"  onClick={() => setShowPassword(!showPassword)}>
                                                             {showPassword ? <svg className="MuiSvg" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="VisibilityIcon"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg> : <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="VisibilityOffIcon"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"></path></svg>}
                                                            
                                                        </button>
                                                    </div>
                                                 
                                         

                                             
                                              <div className="col-12">
                                                    <div className="ally-forgotpassword">
                                                        <div className="ally-remember">
                                                            <label >
                                                               <input
                                                               className="remember-me__check" tabindex="0" role="checkbox"
                                                                    type="checkbox"
                                                                  checked={rememberMe}
                                                                  onChange={(e) => setRememberMe(e.target.checked)}
                                                                />
                                                             
                                                                  <p className="remember-me__label">Remember me</p>
                                                                </label>
                                                          
                                                        </div><a href="/forgotpassword">
                                                            <p className="forgot-password">Forgot password?</p>
                                                        </a>
                                                    </div>
                                                </div>
                                               
                                            <div className="button-group">
                                               
                                                <div className="button-grid">
                                                    <button type="submit" className="button mt-0" disabled={isSubmitting}>
                                                        {isSubmitting ? "Logging in..." : "Login"}
                                                    </button>
                                                </div>
                                                
                                            </div>
                                        </form>
                                        <div className="col-12 mt-3">
                                             <div className="signup-login">Don't have an account?&nbsp;<a className="register-link" href="/register">&nbsp; Sign up</a></div>
                                        </div>
                                    
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
            <Footer />
        </div>)
}

export default Login;